import React from 'react';
import { FilterState, Province, StoreTier, MediaType, SlotStatus } from '../../data/types';
import { provinces, tiers } from '../../data/stores';
import { Select } from '../ui/Select';
import { Button } from '../ui/Button';
interface FilterBarProps {
  filters: FilterState;
  onFilterChange: (filters: FilterState) => void;
}
const mediaTypes: MediaType[] = ['Digital Outposts', 'Digital Drive Aisle', 'Digital Windows'];
export function FilterBar({
  filters,
  onFilterChange
}: FilterBarProps) {
  const handleChange = (key: keyof FilterState, value: string) => {
    onFilterChange({
      ...filters,
      [key]: value
    });
  };
  const clearFilters = () => {
    onFilterChange({
      province: 'all',
      tier: 'all',
      mediaType: 'all',
      availability: 'all'
    });
  };
  const hasActiveFilters = filters.province !== 'all' || filters.tier !== 'all' || filters.mediaType !== 'all' || filters.availability !== 'all';
  return <div className="bg-surface-warm border-b border-border px-6 py-3" data-id="element-859">
      <div className="flex items-end gap-4" data-id="element-860">
        <div className="w-44" data-id="element-861">
          <Select label="Region" placeholder="All Provinces" value={filters.province} onChange={e => handleChange('province', e.target.value)} options={provinces.map(p => ({
          value: p,
          label: p
        }))} data-id="element-862" />
        </div>

        <div className="w-40" data-id="element-863">
          <Select label="Store Tier" placeholder="All Tiers" value={filters.tier} onChange={e => handleChange('tier', e.target.value)} options={tiers.map(t => ({
          value: t,
          label: t.charAt(0).toUpperCase() + t.slice(1).replace('-', ' ')
        }))} data-id="element-864" />
        </div>

        <div className="w-44" data-id="element-865">
          <Select label="Media Type" placeholder="All Types" value={filters.mediaType} onChange={e => handleChange('mediaType', e.target.value)} options={mediaTypes.map(m => ({
          value: m,
          label: m
        }))} data-id="element-866" />
        </div>

        <div className="w-36" data-id="element-867">
          <Select label="Availability" placeholder="Any Status" value={filters.availability} onChange={e => handleChange('availability', e.target.value as SlotStatus | 'all')} options={[{
          value: 'available',
          label: 'Available'
        }, {
          value: 'booked',
          label: 'Booked'
        }, {
          value: 'blocked',
          label: 'Blocked'
        }]} data-id="element-868" />
        </div>

        {hasActiveFilters && <Button variant="ghost" size="sm" onClick={clearFilters} className="mb-0.5" data-id="element-869">
            Clear All
          </Button>}
      </div>
    </div>;
}